export default "__VITE_PUBLIC_ASSET__de6e757e__"